// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer-down0830[data-v-0e0dbc4d]{height:15vh}.footer-down0830 .down-a[data-v-0e0dbc4d]{background:#d22830}", ""]);
// Exports
module.exports = exports;
